import { useState } from 'react';

import { useApolloClient } from '@apollo/client';

import { ATTACH_TREATMENT_DOCUMENTS } from 'services/query/treatmentPlanning';
import { FilesData } from 'types/Files.types';
import {
  TreatmentDocumentRes,
  TreatmentDocumentUploadInput
} from 'types/TreatmentPlanning.types';
import { translate } from 'utils';
import { showToast } from 'utils/toast/toast.util';
import { buildNewScanDocumentsInput } from 'utils/treatmentDocument.utils';

// added as part of ZEN-14826 as smartee doesnt trigger submitTPV based on rescan ticket
export const useAttachSmarteeScans = (
  treatmentId: string | undefined,
  isSmartee?: boolean
) => {
  const client = useApolloClient();
  const [isAttaching, setIsAttaching] = useState(false);

  const attachSmarteeScans = async (
    documents: FilesData[]
  ): Promise<boolean> => {
    if (!treatmentId) return false;

    const documentsInput = buildNewScanDocumentsInput(documents, !!isSmartee);
    if (!documentsInput.length) return true;

    try {
      setIsAttaching(true);
      await client.mutate<TreatmentDocumentRes, TreatmentDocumentUploadInput>({
        mutation: ATTACH_TREATMENT_DOCUMENTS,
        variables: {
          treatmentId,
          documents: documentsInput
        },
        fetchPolicy: 'network-only'
      });
      return true;
    } catch {
      showToast(translate('uploadingStatus.failedToast'), false);
      return false;
    } finally {
      setIsAttaching(false);
    }
  };

  return { attachSmarteeScans, isAttaching };
};
